// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'chat-help';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M16.313 14.063H8.438l-4.5 3.374v-3.375h-2.25a1.125 1.125 0 0 1-1.125-1.124V1.688A1.125 1.125 0 0 1 1.688.563h14.624a1.125 1.125 0 0 1 1.125 1.125v11.25a1.125 1.125 0 0 1-1.125 1.124z' />
    <path d='M6.75 5.063a2.25 2.25 0 1 1 3 2.121A1.125 1.125 0 0 0 9 8.246v.192m0 2.812a.281.281 0 1 1 0-.563m0 .563a.281.281 0 1 0 0-.563' />
  </g>
);

export const viewBox = '0 0 18 18';
